import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/AmazonECS'

const AmazonECS: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'Amazon ECS コンテナ CI/CD デプロイ'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/amazonecs/'}
        title="Amazon ECS | サービス | Aitria（アイトリア）"
        description="Amazon ECS導入支援は、お客さまのビジネスニーズに合わせたECS環境の設計、構築、運用をサポートします。豊富な経験と専門知識を活かし、スムーズなコンテナ環境への移行と効率的な運用を実現。Amazon ECSのコンテナ管理を最適化し、CI/CDプロセスを構築することで、開発とデプロイのスピードを大幅に向上させます。"
      />
      <Template />
    </>
  )
}

export default AmazonECS
